import React,{useState} from "react";
import Slider from "react-slick";
import leftArrow from '../images/left_arrow.png'
import rightArrow from '../images/right_arrow.png'
import ImageAspectRatio from "./shop/utils/ImageAspectRatio";

let placeholderimage = 'https://lh3.googleusercontent.com/proxy/qcaaUkbcopGvjPW5_-_wEiJu6jryzgVNhW59x4ZQlCfJ-BMW-1mwNCp2ZoDMiXeD7tHMpJwJMNgm8Xyk66dDiF-fqPFxBBp9L5P_IZATBbaiceQXo2m-N0uCp8V899sRYcOAiEBTIGEm';

function PrevArrow(props) {
  const { className, style, onClick } = props;
  return (
    <div style={{ ...style, display: "block", background: "red",position:"absolute", top:"25%",zIndex:"99999" }} onClick={onClick}>
      <img src={leftArrow} alt=""/>
    </div>
  );
}
function NextArrow(props) {
  const { className, style, onClick } = props;
  return (
    <div style={{ ...style, display: "block", background: "red",position:"absolute", top:"25%",right:"0",zIndex:"99999" }} onClick={onClick}>
      <img  src={rightArrow} style={{width:"100px"}} alt=""/>
    </div>
  );
}


export default function MySlider(props) {
    const immagini= props.immagini
    const aspectratio = props.aspectratio
    var settings = {
      initialSlide:0,
      slidesToShow: 1,
      slidesToScroll: 1,
      // centerMode: true,
      arrows: false,
      dots: true,
      adaptiveHeight: true, //add this line
      nextArrow:<NextArrow />,
      prevArrow:<PrevArrow />
      };

    return (
        <Slider {...settings} style={{width:"100%",maxHeight:"400px"}}>
        {immagini.map((immagine,i)=>{
          return(
            <ImageAspectRatio key={i} aspectratio={"4:3"}  src={immagine.file} alt={immagine.alt}></ImageAspectRatio> 
          )
        })}
        {immagini.length===0 ? <ImageAspectRatio aspectratio={"4:3"}  src={placeholderimage} alt={""}></ImageAspectRatio>:null}
      </Slider>
    )
}

export function GenericSlider(props) {
  let maxHeight = props.maxHeight ? props.maxHeight : "400px";
  var settings = {
    initialSlide:0,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,
    speed:1500,
    autoplaySpeed: 3000,
    // centerMode: true,
    arrows: props.arrows,
    dots: props.dots,
    adaptiveHeight: false, //add this line
    nextArrow:<NextArrow />,
    prevArrow:<PrevArrow />
    };

  return (
      <Slider {...settings} style={{width:"100%",maxHeight:maxHeight}}>
        {props.children}
      </Slider>
  )
}
